import styled from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;

export const Header = styled.div`
  width: 250px;

  h2 {
    font-size: 28px;
  }

  > span {
    top: -5px;
    margin-left: 33px;
    position: relative;
  }
`;

export const Content = styled.div``;
